import { render, staticRenderFns } from "./freeTimeRecord.vue?vue&type=template&id=fb2efc0c&scoped=true&"
import script from "./freeTimeRecord.vue?vue&type=script&lang=js&"
export * from "./freeTimeRecord.vue?vue&type=script&lang=js&"
import style0 from "./freeTimeRecord.vue?vue&type=style&index=0&id=fb2efc0c&scoped=true&lang=css&"
import style1 from "./freeTimeRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2efc0c",
  null
  
)

export default component.exports